import * as React from "react";


import * as LF from "leaflet";
import 'leaflet/dist/leaflet.css'

import Highcharts from "highcharts";

import highchartsMap from "highcharts/modules/map";

import MapData from "../../ug/tzmap";
import HighchartsReact from "highcharts-react-official";

highchartsMap(Highcharts); // Initialize the map module


const nationalOption = {
    chart: {
        renderTo: 'high-chart-donut0',
        type: 'pie'
    },
    title: {
        text: 'Total Area per Land Use Plan'
    },
    yAxis: {
        title: {
            text: 'Total percent market share'
        }
    },
    plotOptions: {
        pie: {
            shadow: true
        }
    },
    tooltip: {
        formatter: function () {
            return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
        }
    },
    series: [{
        name: 'LandUse',
        data: [["Agriculture", 40], ["Settlement", 30], ["Forest", 10], ["Investment", 15], ["Reserve", 5]],
        size: '100%',
        innerSize: '10%',
        showInLegend: true,
        dataLabels: {
            enabled: true
        }
    }]
}

const nationalOptionBar = {
    chart: {
        renderTo: 'high-chart-donut',
        type: 'column'
    },

    title: {
        text: 'Zonal increase in Land Use Planning'
    },

    subtitle: {
        text: ''
    },

    yAxis: {
        title: {
            text: 'Number of Land Use Plans'
        }
    },

    xAxis: {
        accessibility: {
            rangeDescription: 'Range: 2013 to 2023'
        }
    },

    legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
            pointStart: 2013
        }
    },

    series: [{
        name: 'Eastern',
        data: [536, 234, 571, 696, 370, 119, 137, 154,645]
        },
        {
            name: 'Central',
            data: [345, 432, 571, 696, 470, 119, 137, 154, 175]
        },
        {
            name: 'Southern',
            data: [439, 525, 571, 235, 82, 432, 61, 154, 652]
        },
        {
            name: 'Northern',
            data: [164, 654, 571, 696, 97, 119, 137, 236, 423]
        },
        {
            name: 'Lake',
            data: [122, 543, 333, 345, 55, 100, 167, 222, 542]
        },
        {
            name: 'Southern Highlands',
            data: [212, 431, 444, 565, 87, 122, 100, 59, 466]
        },
        {
            name: 'Southern West Highlands',
            data: [439, 300, 70, 238, 97, 119, 288, 100, 296]
        },
        {
            name: 'Western',
            data: [249, 240, 297, 298, 324, 308, 381, 404,340]
        }],

    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    }
}

export default class DashboardStakeholderPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current_dashboard: <div>Loading...</div>,
            dashboard_data:
                {
                    national: {
                        total: '1',
                        ongoing: '0',
                        active: '1',
                        expiry: '0'
                    },
                    zonal: {
                        total: '5',
                        ongoing: '1',
                        active: '3',
                        expiry: '1'
                    },
                    regional: {
                        total: '30',
                        ongoing: '5',
                        active: '24',
                        expiry: '1'
                    },
                    district: {
                        total: '105',
                        ongoing: '13',
                        active: '91',
                        expiry: '1'
                    },
                    village: {
                        total: '1345',
                        ongoing: '212',
                        active: '1104',
                        expiry: '29'
                    }
                }

        }
        this.setInitialScreen = this.setInitialScreen.bind(this)

    }

    componentDidMount() {
        this.fetchCharts()

        let localityLevel = JSON.parse(sessionStorage.getItem('decoded')).locality
        console.log('HAPA [[ ')
        console.log(localityLevel)
        this.setInitialScreen(localityLevel)
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
        console.log(e.target.value)
        let dashboard = this.getDashboardByLocality(e.target.value);
        this.setState({current_dashboard: dashboard})
    }

    setInitialScreen(localityLevel) {
        let dashboard = this.getDashboard();
        this.setState({current_dashboard: dashboard})
    }


    getDashboard() {
        return this.getNationalDashboard();
    }


    render() {
        return (<div id={'dashboard_content'}
                     style={{padding: '24px', height: '95%', marginRight: '4px', overflowY: 'auto'}}>

            {this.state.current_dashboard}

        </div>)
    }


    fetchCharts() {


        setTimeout(function () { // Otherwise innerHTML doesn't update

            const mapData = MapData.map_data
            const data = MapData.data

            Highcharts.mapChart('ramani', {
                chart: {
                    map: mapData,
                    borderWidth: 1,
                    marginRight: 0 // for the legend
                },

                title: {
                    text: 'Landuse, February 2023'
                },

                accessibility: {
                    description: 'Displaying Birth Registration.'
                },

                legend: {
                    layout: 'vertical',
                    align: 'right',
                    floating: true,
                    backgroundColor: ( // theme
                        Highcharts.defaultOptions &&
                        Highcharts.defaultOptions.legend &&
                        Highcharts.defaultOptions.legend.backgroundColor
                    ) || 'rgba(255, 255, 255, 0.85)'
                },

                mapNavigation: {
                    enabled: true
                },

                colorAxis: {
                    min: 0,
                    max: 25,
                    tickInterval: 5,
                    stops: [[0, '#F1EEF6'], [0.65, '#900037'], [1, '#500007']],
                    labels: {
                        format: '{value}%'
                    }
                },

                plotOptions: {
                    mapline: {
                        showInLegend: false,
                        enableMouseTracking: false
                    }
                },

                series: [{
                    data: data,
                    joinBy: ['hc-key', 'code'],
                    name: 'Birth Registration rate',
                    tooltip: {
                        valueSuffix: '%'
                    },
                    borderWidth: 0.5,
                    states: {
                        hover: {
                            color: '#a4edba'
                        }
                    },
                    shadow: false,
                    accessibility: {
                        enabled: false
                    }
                }, {
                    type: 'mapline',
                    name: 'State borders',
                    color: 'white',
                    shadow: false,
                    borderWidth: 2,
                    accessibility: {
                        enabled: false
                    }
                }]
            });

        }, 0);
    }

    getNationalDashboard() {
        return <div>
            <div className={'row'} style={{marginTop: '16px'}}>
                <div className={'col col-sm-8'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid darkcyan', height: '48vh'}}>
                        <div style={{width: '100%', height: '100%', background: '#fff'}} id={'ramani'}>
                        </div>
                    </div>
                </div>
                <div className={'col col-sm-4'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #c0c', height: '45vh'}}>
                        <div style={{height: '100%', width: '100%', overflowY: 'auto'}} id={'high-chart-donut0'}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={nationalOption}
                            />
                        </div>
                    </div>
                    {/*   <div className={'ucard'}
                         style={{borderBottom: '2px solid #484848', height: '21vh', marginTop: '24px'}}>
                        <div style={{height: '100%', overflowY: 'auto'}} id={'high-chart-donut1'}>
                        </div>
                    </div>*/}
                </div>
            </div>
            <div className={'row'} style={{marginTop: '16px'}}>
                <div className={'col col-sm-12'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid darkcyan', height: '40vh'}}
                         id={'high-chart-bar'}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={nationalOptionBar}
                        />
                    </div>
                </div>
            </div>
        </div>
    }
}